import React from 'react';

class LocaleDefaultValueDropdown extends React.Component {

    constructor(props) {

        super();
        this.onSelectChange = this.onSelectChange.bind(this);
    }

    onSelectChange(e) {

        return this.props.onUpdated(e.target.value);
    }

    render() {

        return (
            <div className="row" style={{ marginTop: '0.5rem' }}>
                <div className="col-12">
                    <span className="text-left" style={{ fontSize: '0.85rem' }}>
                        <strong>{this.props.title}</strong>
                    </span>
                    <div className="row">
                        <div className="col-12">
                            <select className="form-control" value={this.props.value || ""} onChange={this.onSelectChange}>
                                <option key="none" value="">None</option>
                                {
                                    (this.props.menuItems || []).map((item) => {
                                        return (
                                            <option key={item.id} value={item.id}>
                                                {item.label}
                                            </option>
                                        );
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LocaleDefaultValueDropdown;
